import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f2120ff"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2120ff')) {
      api.createRecord('0f2120ff', component.options)
    } else {
      api.reload('0f2120ff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f2120ff", function () {
      api.rerender('0f2120ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabRefresh/index.vue"
export default component.exports